/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof Link
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    resourceFragment?: string;
}

/**
 * Check if a given object implements the Link interface.
 */
export function instanceOfLink(value: object): value is Link {
    return true;
}

export function LinkFromJSON(json: any): Link {
    return LinkFromJSONTyped(json, false);
}

export function LinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Link {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'href': json['href'] == null ? undefined : json['href'],
        'rel': json['rel'] == null ? undefined : json['rel'],
        'mediaType': json['mediaType'] == null ? undefined : json['mediaType'],
        'text': json['text'] == null ? undefined : json['text'],
        'resourceFragment': json['resourceFragment'] == null ? undefined : json['resourceFragment'],
    };
}

export function LinkToJSON(json: any): Link {
    return LinkToJSONTyped(json, false);
}

export function LinkToJSONTyped(value?: Link | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'href': value['href'],
        'rel': value['rel'],
        'mediaType': value['mediaType'],
        'text': value['text'],
        'resourceFragment': value['resourceFragment'],
    };
}

